module.exports = __webpack_public_path__ + "img/symbol_9.e8e75097.png";